module.exports = __webpack_public_path__ + "static/lights27-79efa1e8750c247828ff79151c35d181.jpg";